
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/pegasus",
      function () {
        return require("private-next-pages/case-studies/pegasus.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies/pegasus"])
      });
    }
  